class InitialDataService {
  constructor($http, AuthenticationService, $state, FoodBenefitUserDataService, FoodBenefitEmployeeRepositoryService) {
    'ngInject';
    this.$http = $http;
    this.employeeRepositoryService = FoodBenefitEmployeeRepositoryService;
    this.state = $state;
    this.userDataService = FoodBenefitUserDataService;
    this.employeeId = AuthenticationService.getEmployeeId();
  }

  initMainData() {
    return this.employeeRepositoryService.getEmployee(this.employeeId)
      .then((employee) => {
        this.userDataService.setEmployee(employee);
        this.manager = employee.isManager();
        return employee;
      })
      .catch(err => {
        throw err;
      });
  }
}

export default InitialDataService;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/initialData/initialData.service.js